import React, { useState, useCallback } from 'react';
import { ProgressBreadcrumbList, ProgressBreadcrumbListTheme } from '@apply/components';
import { DemoSection } from './common/SectionNavigator';
import { DemoExample, DemoPage, DemoPageSection } from './common/DemoLayout';

const sections: DemoSection[] = [
    { id: 'progressBreadcrumbListDemo_bluevertical', title: 'Blue (Vertical)' },
    { id: 'progressBreadcrumbListDemo_whitevertical', title: 'White (Vertical)' },
    { id: 'progressBreadcrumbListDemo_redvertical', title: 'Red (Vertical)' },
    { id: 'progressBreadcrumbListDemo_greyvertical', title: 'Grey (Vertical)' },
    { id: 'progressBreadcrumbListDemo_bluehorizontal', title: 'Blue (Horizontal)' },
    { id: 'progressBreadcrumbListDemo_whitehorizontal', title: 'White (Horizontal)' },
    { id: 'progressBreadcrumbListDemo_redhorizontal', title: 'Red (Horizontal)' },
    { id: 'progressBreadcrumbListDemo_greyhorizontal', title: 'Grey (Horizontal)' },
];

export const ProgressBreadcrumbListDemo: React.FC = () => {
    const [blueVertCrumb, set_blueVertCrumb] = useState(3);
    const [whiteVertCrumb, set_whiteVertCrumb] = useState(3);
    const [redVertCrumb, set_redVertCrumb] = useState(3);
    const [grayVertCrumb, set_grayVertCrumb] = useState(3);

    const handleNextCrumbClick = (currentItem: number, maxCount: number, setUpdate: (value: number) => void) => {
        if (currentItem + 1 <= maxCount) {
            setUpdate(currentItem + 1);
        }
    };

    const handlePreviousCrumbClick = (currentItem: number, set_Update: (value: number) => void) => {
        if (currentItem - 1 > 0) {
            set_Update(currentItem - 1);
        }
    };

    const crumbClick: React.MouseEventHandler = useCallback((event) => {
        alert(event.currentTarget.id + ' clicked.');
    }, []);

    const crumbs = [
        { id: 'basicInfoCrumb', number: 1, children: 'Basic Info', handleClick: crumbClick },
        { id: 'propertyCrumb', number: 2, children: 'Property', handleClick: crumbClick },
        { id: 'budgetCrumb', number: 3, children: 'Budget', handleClick: crumbClick },
        { id: 'specsCrumb', number: 4, children: 'Specs', handleClick: crumbClick },
        { id: 'reviewCrumb', number: 5, children: 'Review', handleClick: crumbClick },
    ];

    return (
        <DemoPage
            title='Progress Breadcrumb Timeline :'
            sections={sections}
        >
            <DemoPageSection id={sections[0].id}>
                <DemoExample label='Blue Theme (Vertical)'>
                    <button
                        onClick={(e) => handlePreviousCrumbClick(blueVertCrumb, set_blueVertCrumb)}
                        style={{ marginRight: '0.5rem' }}
                    >
                        Previous Crumb
                    </button>
                    <button
                        onClick={(e) => handleNextCrumbClick(blueVertCrumb, crumbs.length, set_blueVertCrumb)}
                        style={{ marginRight: '0.5rem' }}
                    >
                        Next Crumb
                    </button>
                </DemoExample>
                <DemoExample>
                    <ProgressBreadcrumbList
                        id='blueDemo'
                        theme={ProgressBreadcrumbListTheme.Blue}
                        activeCrumbNumber={blueVertCrumb}
                        crumbs={crumbs}
                    />
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection id={sections[1].id}>
                <DemoExample label='White Theme (Vertical)'>
                    <button
                        onClick={(e) => handlePreviousCrumbClick(whiteVertCrumb, set_whiteVertCrumb)}
                        style={{ marginRight: '0.5rem' }}
                    >
                        Previous Crumb
                    </button>
                    <button
                        onClick={(e) => handleNextCrumbClick(whiteVertCrumb, crumbs.length, set_whiteVertCrumb)}
                        style={{ marginRight: '0.5rem' }}
                    >
                        Next Crumb
                    </button>
                </DemoExample>
                <DemoExample>
                    <ProgressBreadcrumbList
                        id='whiteDemo'
                        theme={ProgressBreadcrumbListTheme.White}
                        activeCrumbNumber={whiteVertCrumb}
                        crumbs={crumbs}
                    />
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection id={sections[2].id}>
                <DemoExample label='Red Theme (Vertical)'>
                    <button
                        onClick={(e) => handlePreviousCrumbClick(redVertCrumb, set_redVertCrumb)}
                        style={{ marginRight: '0.5rem' }}
                    >
                        Previous Crumb
                    </button>
                    <button
                        onClick={(e) => handleNextCrumbClick(redVertCrumb, crumbs.length, set_redVertCrumb)}
                        style={{ marginRight: '0.5rem' }}
                    >
                        Next Crumb
                    </button>
                </DemoExample>
                <DemoExample>
                    <ProgressBreadcrumbList
                        id='redDemo'
                        theme={ProgressBreadcrumbListTheme.Red}
                        activeCrumbNumber={redVertCrumb}
                        crumbs={crumbs}
                    />
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection id={sections[3].id}>
                <DemoExample label='Grey Theme (Vertical)'>
                    <button
                        onClick={(e) => handlePreviousCrumbClick(grayVertCrumb, set_grayVertCrumb)}
                        style={{ marginRight: '0.5rem' }}
                    >
                        Previous Crumb
                    </button>
                    <button
                        onClick={(e) => handleNextCrumbClick(grayVertCrumb, crumbs.length, set_grayVertCrumb)}
                        style={{ marginRight: '0.5rem' }}
                    >
                        Next Crumb
                    </button>
                </DemoExample>
                <DemoExample>
                    <ProgressBreadcrumbList
                        id='greyDemo'
                        theme={ProgressBreadcrumbListTheme.Gray}
                        activeCrumbNumber={grayVertCrumb}
                        crumbs={crumbs}
                    />
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection id={sections[4].id}>
                <DemoExample label='Blue Theme (Horizontal)'>
                    <button
                        onClick={(e) => handlePreviousCrumbClick(blueVertCrumb, set_blueVertCrumb)}
                        style={{ marginRight: '0.5rem' }}
                    >
                        Previous Crumb
                    </button>
                    <button
                        onClick={(e) => handleNextCrumbClick(blueVertCrumb, crumbs.length, set_blueVertCrumb)}
                        style={{ marginRight: '0.5rem' }}
                    >
                        Next Crumb
                    </button>
                </DemoExample>
                <DemoExample>
                    <ProgressBreadcrumbList
                        id='blueDemo'
                        theme={ProgressBreadcrumbListTheme.Blue}
                        activeCrumbNumber={blueVertCrumb}
                        crumbs={crumbs}
                        orientation='horizontal'
                    />
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection id={sections[5].id}>
                <DemoExample label='White Theme (Horizontal)'>
                    <button
                        onClick={(e) => handlePreviousCrumbClick(whiteVertCrumb, set_whiteVertCrumb)}
                        style={{ marginRight: '0.5rem' }}
                    >
                        Previous Crumb
                    </button>
                    <button
                        onClick={(e) => handleNextCrumbClick(whiteVertCrumb, crumbs.length, set_whiteVertCrumb)}
                        style={{ marginRight: '0.5rem' }}
                    >
                        Next Crumb
                    </button>
                </DemoExample>
                <DemoExample>
                    <ProgressBreadcrumbList
                        id='whiteDemo'
                        theme={ProgressBreadcrumbListTheme.White}
                        activeCrumbNumber={whiteVertCrumb}
                        crumbs={crumbs}
                        orientation='horizontal'
                    />
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection id={sections[6].id}>
                <DemoExample label='Red Theme (Horizontal)'>
                    <button
                        onClick={(e) => handlePreviousCrumbClick(redVertCrumb, set_redVertCrumb)}
                        style={{ marginRight: '0.5rem' }}
                    >
                        Previous Crumb
                    </button>
                    <button
                        onClick={(e) => handleNextCrumbClick(redVertCrumb, crumbs.length, set_redVertCrumb)}
                        style={{ marginRight: '0.5rem' }}
                    >
                        Next Crumb
                    </button>
                </DemoExample>
                <DemoExample>
                    <ProgressBreadcrumbList
                        id='redDemo'
                        theme={ProgressBreadcrumbListTheme.Red}
                        activeCrumbNumber={redVertCrumb}
                        crumbs={crumbs}
                        orientation='horizontal'
                    />
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection id={sections[7].id}>
                <DemoExample label='Grey Theme (Horizontal)'>
                    <button
                        onClick={(e) => handlePreviousCrumbClick(grayVertCrumb, set_grayVertCrumb)}
                        style={{ marginRight: '0.5rem' }}
                    >
                        Previous Crumb
                    </button>
                    <button
                        onClick={(e) => handleNextCrumbClick(grayVertCrumb, crumbs.length, set_grayVertCrumb)}
                        style={{ marginRight: '0.5rem' }}
                    >
                        Next Crumb
                    </button>
                </DemoExample>
                <DemoExample>
                    <ProgressBreadcrumbList
                        id='greyDemo'
                        theme={ProgressBreadcrumbListTheme.Gray}
                        activeCrumbNumber={grayVertCrumb}
                        crumbs={crumbs}
                        orientation='horizontal'
                    />
                </DemoExample>
            </DemoPageSection>
        </DemoPage>
    );
};
